// extracted by mini-css-extract-plugin
export default {"container":"I0_QLEF0YJRQPOBb3GrQ","mainContent":"Fako7mJfqwM3rd080flu"};